// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInputLight_container__323w5","input":"TextInputLight_input__STDaF","clear":"TextInputLight_clear__1KxwL"};